import iconAssociate from "../../img/associate.png";

export default function Sociais() {
  return (
    <>
      <a href="https://github.com/wagstalos" target="_blank" rel="noreferrer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-brand-github"
          width="34"
          height="34"
          viewBox="0 0 24 24"
          stroke-width="1"
          stroke="#08b9bb"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M9 19c-4.3 1.4 -4.3 -2.5 -6 -3m12 5v-3.5c0 -1 .1 -1.4 -.5 -2c2.8 -.3 5.5 -1.4 5.5 -6a4.6 4.6 0 0 0 -1.3 -3.2a4.2 4.2 0 0 0 -.1 -3.2s-1.1 -.3 -3.5 1.3a12.3 12.3 0 0 0 -6.2 0c-2.4 -1.6 -3.5 -1.3 -3.5 -1.3a4.2 4.2 0 0 0 -.1 3.2a4.6 4.6 0 0 0 -1.3 3.2c0 4.6 2.7 5.7 5.5 6c-.6 .6 -.6 1.2 -.5 2v3.5" />
        </svg>
      </a>

      <a
        href="https://www.linkedin.com/in/wagner-silva-6a163555/"
        target="_blank"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-brand-linkedin"
          width="34"
          height="34"
          viewBox="0 0 24 24"
          stroke-width="1"
          stroke="#08b9bb"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <rect x="4" y="4" width="16" height="16" rx="2" />
          <line x1="8" y1="11" x2="8" y2="16" />
          <line x1="8" y1="8" x2="8" y2="8.01" />
          <line x1="12" y1="16" x2="12" y2="11" />
          <path d="M16 16v-3a2 2 0 0 0 -4 0" />
        </svg>
      </a>

      <a
        href="https://www.instagram.com/wagner.paulo89/"
        target="_blank"
        rel="noreferrer"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-brand-instagram"
          width="34"
          height="34"
          viewBox="0 0 24 24"
          stroke-width="1"
          stroke="#08b9bb"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <rect x="4" y="4" width="16" height="16" rx="4" />
          <circle cx="12" cy="12" r="3" />
          <line x1="16.5" y1="7.5" x2="16.5" y2="7.501" />
        </svg>
      </a>

      <a href="mailto:wagstalos@hotmail.com" target="_blank" rel="noreferrer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-mail"
          width="34"
          height="34"
          viewBox="0 0 24 24"
          stroke-width="1"
          stroke="#08b9bb"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <rect x="3" y="5" width="18" height="14" rx="2" />
          <polyline points="3 7 12 13 21 7" />
        </svg>
      </a>

      <a
        href="https://www.behance.net/wagstalos89"
        target="_blank"
        rel="noreferrer"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="34"
          height="34"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#08b9bb"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="icon icon-tabler icons-tabler-outline icon-tabler-brand-behance"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M3 18v-12h4.5a3 3 0 0 1 0 6a3 3 0 0 1 0 6h-4.5" />
          <path d="M3 12l4.5 0" />
          <path d="M14 13h7a3.5 3.5 0 0 0 -7 0v2a3.5 3.5 0 0 0 6.64 1" />
          <path d="M16 6l3 0" />
        </svg>
      </a>

      <a href="https://dribbble.com/wagstalos" target="_blank" rel="noreferrer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="34"
          height="34"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#08b9bb"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="icon icon-tabler icons-tabler-outline icon-tabler-brand-dribbble"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
          <path d="M9 3.6c5 6 7 10.5 7.5 16.2" />
          <path d="M6.4 19c3.5 -3.5 6 -6.5 14.5 -6.4" />
          <path d="M3.1 10.75c5 0 9.814 -.38 15.314 -5" />
        </svg>
      </a>
      <br />

      <div className="line"></div>

      <a
        href="https://trailblazer.me/id/wdasilva13"
        target="_blank"
        rel="noreferrer"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 162.24 162.22"
          className="trailhead"
        >
          <path
            d="m84 162.22h.4a144.79 144.79 0 0 0 75.33-24.22 5.81 5.81 0 0 0 2.5-4.75v-11.58a129.65 129.65 0 0 0 -78.82-121.2 5.79 5.79 0 0 0 -4.58 0 129.65 129.65 0 0 0 -78.83 121.2v11.58a5.82 5.82 0 0 0 2.39 4.75 144.85 144.85 0 0 0 78.73 24.27z"
            fill="#032e61"
          />
          <path
            d="m26.94 101.42 37.74-55.28a5.78 5.78 0 0 1 9.56 0l18.5 27.05 6.81-9.7a5.71 5.71 0 0 1 1.45-1.49 5.79 5.79 0 0 1 8.06 1.47l26.3 38.06h13.76c-10.78-66.91-63.58-87.4-68-89.39 0 0-22 7.84-41.53 31.29a116.6 116.6 0 0 0 -26.38 58z"
            fill="#8cd3f8"
          />
          <path
            d="m121.36 101.54-17.03-24.58-8.26 11.94 9.54 12.62z"
            fill="#a372b5"
          />
          <path d="m96.07 88.9-8.71 12.6 18.25.02z" fill="#741b89" />
          <path
            d="m54.93 81.07 14.85 20.41h3.45l12.56-18.09-13.3-19.46-2.93-4.26z"
            fill="#a372b5"
          />
          <path d="m54.93 81.07-13.93 20.37 28.78.04z" fill="#741b89" />
          <path
            d="m85.66 142.06a3.58 3.58 0 0 0 -1.83-4.72l-5.33-2.34a16.48 16.48 0 0 1 -1.9-1 15.23 15.23 0 0 1 -4.8-21h-59.91c-.29 2.9-.29 5.79-.29 8.69v8.49a136.8 136.8 0 0 0 39.34 16.67c10.59 2.37 20 3.84 29.77 3.91l4.78-8.33a3.78 3.78 0 0 0 .17-.37z"
            fill="#009a44"
          />
          <path
            d="m150.44 113h-63.67l-4.84 5.82a3.71 3.71 0 0 0 -.52.88 3.58 3.58 0 0 0 1.92 4.68l5.33 2.36c.48.21.94.45 1.39.7a15.22 15.22 0 0 1 5.65 20.76l-1 1.68c3-.39 6.14-.9 9.41-1.57a137.82 137.82 0 0 0 16.42-4.24c.82-.25 2.49-.83 2.49-.83a139.12 139.12 0 0 0 27.57-13.08l.09-8.49c.05-2.9-.07-5.79-.24-8.67z"
            fill="#009a44"
          />
          <path
            d="m90.05 127.42c-.45-.25-.91-.49-1.39-.7l-5.33-2.36a3.58 3.58 0 0 1 -1.92-4.68 3.71 3.71 0 0 1 .52-.88l4.84-5.8h-15a15.23 15.23 0 0 0 4.8 21 16.48 16.48 0 0 0 1.9 1l5.33 2.35a3.58 3.58 0 0 1 1.83 4.72 3.78 3.78 0 0 1 -.17.35l-4.78 8.33a105.4 105.4 0 0 0 14-.86l1-1.68a15.22 15.22 0 0 0 -5.63-20.79z"
            fill="#fff"
          />
          <g fill="#046a38">
            <path d="m111.37 131.87h17.27l-8.64-9.87z" />
            <path d="m42.3 138.86h17.27l-8.64-9.87z" />
            <path d="m34 118.61-8.64 9.86h17.27z" />
          </g>
        </svg>
      </a>

      <a
        href="https://trailblazer.me/id/wdasilva13"
        target="blank"
        rel="noreferrer"
      >
        <img
          src={iconAssociate}
          alt="icon associate"
          title="Associate"
          style={{ width: "90px" }}
        />
      </a>
    </>
  );
}
